import React from "react";

const ProviderTypeCard = ({ title, tags }) => (
  <tr className="provider-beta__type-row">
    <th scope="row" className="provider-beta__type-title">
      {title}
    </th>
    <td className="provider-beta__type-tags">{tags}</td>
  </tr>
);

export default ProviderTypeCard;
